import { usersApi } from '../api/usersApi'

export const sendUserPassword = async (email: string) => {
  try {
    const {
      data: { message },
    } = await usersApi.sendUserPassword(email)
    return message
  } catch (error) {
    console.error(`Error creating user: `, error)
    throw error
  }
}
